import type { TourOperatorType } from '@travel-planner/shared/schemas/operations';
import type { OperationItem } from './types';

// Legacy parity (OperationItem/index.tsx:257-265): a Driver can be assigned to
// Transportation items EXCEPT these subcategories, which carry their own
// crew/operator and never take a driver.
const DRIVER_EXCLUDED_SUBCATEGORIES = [
  'Helicopter',
  'Ferry',
  'Flight',
  'Train',
  'Cruise',
] as const;

type EligibilityItem = Pick<
  OperationItem,
  'contentCategory' | 'contentSubcategory'
>;

// A Driver is assignable to a Transportation item that isn't one of the
// self-crewed subcategories above.
export const canAssignDriver = (item: EligibilityItem): boolean =>
  item.contentCategory === 'Transportation' &&
  !DRIVER_EXCLUDED_SUBCATEGORIES.includes(
    item.contentSubcategory as (typeof DRIVER_EXCLUDED_SUBCATEGORIES)[number]
  );

// A Guide is assignable to any item whose subcategory is "Guide".
export const isGuideItem = (item: EligibilityItem): boolean =>
  item.contentSubcategory === 'Guide';

// The operator type an item accepts, or null when it takes none. Drivers take
// precedence (a Transportation item is never a Guide); the footer + add-picker
// render only when this is non-null.
export const assignableOperatorType = (
  item: EligibilityItem
): TourOperatorType | null => {
  if (canAssignDriver(item)) return 'Driver';
  if (isGuideItem(item)) return 'Guide';
  return null;
};

export const canAssignOperator = (item: EligibilityItem): boolean =>
  assignableOperatorType(item) !== null;
